import { parseAsString, useQueryState } from 'next-usequerystate'
import { useCallback, useEffect, useMemo } from 'react'

import { QueryParam } from '../constants/query'
import { formatExpiryCode, parseExpiryCode } from '../utils/instruments'
import useIsOptionsPage from './useIsOptionsPage'

export default function useSelectedExpiry(): [Date | null, (expiry: Date | null) => void] {
  const [rawSelectedExpiry, setRawSelectedExpiry] = useQueryState(
    QueryParam.SelectedExpiry,
    parseAsString
  )

  let selectedExpiry = null
  if (rawSelectedExpiry) {
    if (rawSelectedExpiry === '0dte') {
      const expiryCode = formatExpiryCode(new Date())
      selectedExpiry = parseExpiryCode(expiryCode)
    } else {
      selectedExpiry = parseExpiryCode(rawSelectedExpiry)
    }
  }

  const setSelectedExpiry = useCallback(
    (expiry: Date | null) => {
      if (!expiry) {
        setRawSelectedExpiry(null)
        return
      }
      setRawSelectedExpiry(formatExpiryCode(expiry))
    },
    [setRawSelectedExpiry]
  )

  // Note: always prefer selected option's expiry over selected expiry
  // This enables direct links to instruments using the selected option query param
  const expiry = selectedExpiry ? selectedExpiry : null

  const isOptionsPage = useIsOptionsPage()
  useEffect(() => {
    if (!isOptionsPage) {
      setSelectedExpiry(null)
    }
  }, [isOptionsPage, setSelectedExpiry])

  return useMemo(() => [expiry, setSelectedExpiry], [expiry, setSelectedExpiry])
}
